module.exports = __webpack_public_path__ + "img/meme_14.6ace7cca.jpg";